<template>
  <div class="full-width" :style="'background-color: '+data.styles_background_colour+'; color: '+data.styles_font_colour">
    <div v-html="data.content"></div>
  </div>
</template>

<script>
import { firestore } from '../main'

export default {
  name: 'HtmlBlock',
  props: ['data']
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/HtmlBlock.vue